const initialState = {
  commercials: [],
  loading: false,
  createUpdateLoading: false,
  deleteLoading: false,
  error: null,
  pageCount: 0,
  total: 0,
};

const commercialsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "FETCH_COMMERCIALS_LOADING":
      return { ...state, loading: true, error: null };

    case "FETCH_COMMERCIALS_SUCCESS":
      return {
        ...state,
        loading: false,
        commercials: payload.data || [],
        pageCount: payload.meta?.pagination?.pageCount || 0,
        total: payload.meta?.pagination?.total || 0,
        error: null,
      };

    case "FETCH_COMMERCIALS_LOAD_MORE_SUCCESS":
      return {
        ...state,
        loading: false,
        commercials: [...state.commercials, ...(payload.data || [])],
        pageCount: payload.meta?.pagination?.pageCount || 0,
        total: payload.meta?.pagination?.total || 0,
        error: null,
      };

    case "FETCH_COMMERCIALS_ERROR":
      return { ...state, loading: false, error: payload };

    case "CREATE_UPDATE_COMMERCIAL_LOADING":
      return { ...state, createUpdateLoading: true };

    case "CREATE_COMMERCIAL_SUCCESS":
      return {
        ...state,
        createUpdateLoading: false,
        commercials: [payload, ...state.commercials],
        total: state.total + 1,
      };

    case "UPDATE_COMMERCIAL_SUCCESS":
      return {
        ...state,
        createUpdateLoading: false,
        commercials: state.commercials.map((commercial) =>
          commercial?.id === payload?.id ? payload : commercial
        ),
      };

    case "CREATE_UPDATE_COMMERCIAL_ERROR":
      return { ...state, createUpdateLoading: false };

    case "DELETE_COMMERCIAL_LOADING":
      return { ...state, deleteLoading: true };

    case "DELETE_COMMERCIAL_SUCCESS":
      return {
        ...state,
        deleteLoading: false,
        commercials: state.commercials.filter(
          (commercial) => `${commercial?.id}` !== `${payload}`
        ),
        total: Math.max(state.total - 1, 0),
      };

    case "DELETE_COMMERCIAL_ERROR":
      return { ...state, deleteLoading: false };

    default:
      return state;
  }
};

export default commercialsReducer;
